// src/components/organism/AccountOverview/AccountOverviewCard/AccountOverviewCard.tsx
import React from 'react';
import { SettingIcon, IconButton, Card /*, Spinner */ } from 'shared-portal-component';
import '@/components/organism/AccountOverview/AccountOverviewCard/AccountOverviewCard.scss';

interface AccountOverviewCardProps {
  /** Title shown on the top-left */
  title: string;
  /** Click handler for the right-side icon */
  onIconClick?: () => void;
  /** Show loading state over the body */
  loading?: boolean;
  /** Card body */
  children: React.ReactNode;
}

const AccountOverviewCard: React.FC<AccountOverviewCardProps> = ({
  title,
  onIconClick,
  loading = false,
  children,
}) => (
  <Card>
    <div className="titled-card">
      <div className="titled-card__header">
        <h3 className="titled-card__title">{title}</h3>
        <IconButton
          type="button"
          icon={<SettingIcon size="1x" />}
          className="titled-card__icon-btn"
          ariaLabel="card action"
          variant="secondary"
          onClick={onIconClick}
        />
      </div>

      <div className="titled-card__body" aria-busy={loading}>
        {loading ? (
          // Replace with your Spinner/Skeleton if you have one
          // <Spinner size="sm" />
          <div className="titled-card__loading">Loading…</div>
        ) : (
          children
        )}
      </div>
    </div>
  </Card>
);

export default AccountOverviewCard;
